import { ContractTenant } from '../../../../common/validations'

export const isAdultTenant = (tenant: ContractTenant) =>
  'isAdult' in tenant && tenant.isAdult
